import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Card, Typography } from 'antd'
import Genomes from '../../images/genomics/Genomes.svg'
import lycopersicum from '../../images/genomics/lycopersicum.jpg'
import cerasiforme from '../../images/genomics/cerasiforme.jpg'
import pimpinellifolium from '../../images/genomics/pimpinellifolium.jpg'

import './genomics.css'

const { Meta } = Card
const { Title, Paragraph } = Typography

class Genomics extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <img src={Genomes} className="genomes-bg" />
                        <div className="genomes-bg-desc">
                            <Title level={2}>Genomics</Title>
                            <Title level={4}>Collection of tomato reference genome assemblies.</Title>
                        </div>
                    </Col>
                </Row>
                <Row className="genomics-species-card-row" justify="space-around">
			<Paragraph>
				A total of 32 diverse tomato accessions were sequenced with HiFi reads (<Link to="/datasource/2">http://solomics.agis.org.cn/tomato/datasource/2</Link>), including the accession Heinz 1706 used as reference genome (<Link to="/help/sl5.0">http://solomics.agis.org.cn/tomato/help/sl5.0</Link>). Another 14 publicly available genomes were downloaded and annotated (<Link to="/tool/jbrowse_nav">http://solomics.agis.org.cn/tomato/tool/jbrowse_nav</Link>). All genomes can be viewed from <Link to="/tool/jbrowse_nav">http://solomics.agis.org.cn/tomato/tool/jbrowse_nav</Link> and downloaded from <Link to="/ftp">http://solomics.agis.org.cn/tomato/ftp/</Link>.
			</Paragraph>
                </Row>
            </React.Fragment>
        )
    }
}

export default Genomics
